import { Component, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ClientService } from '../services/client.service';
@Component({
  selector: 'app-client-details',
  templateUrl: './client-details.component.html',
  styleUrls: ['./client-details.component.scss']
})







export class ClientDetailsComponent implements OnInit {
  public accessRoles: any;
  public uuid: string = '';
  public expressDetails: any = {};
  public quoteObj: any = [];
  public clientDetailsCont = [];
  // public selectedVersion:string='';
  // public isContractSigned:boolean = false;
  // public isValidContract:boolean = false;
  // public isDiscard:boolean = false;
  // public isSharedWithClient:boolean = false;
  constructor(
    public clientService: ClientService,
    private notifier: NotifierService,
    private router: Router,
    private activaterRoute: ActivatedRoute,
    private dialog: MatDialog
  ) {
    this.accessRoles = JSON.parse(localStorage.getItem('access'));
    this.uuid = this.activaterRoute.snapshot.params['uuid'];
    // this.clientService.onContractDetailsReload
    //   .subscribe(() => {
    //     // this.selectedVersion = '';
    //     console.log("onContractDetailsReload",this.selectedVersion);
    //     this.getClientDetails();
    //   })
  }

  ngOnInit(): void {
    this.clientService.isSearchShow = false;
    this.getClientDetails();
  }

  getClientDetails() {
    this.clientService.getClientDetails(this.uuid).subscribe((result) => {
      if (result["status"] == 1) {
        this.expressDetails = result['data'];
        this.modifyClientDetailsData(result['data']);
        this.clientService.eid = result["eid"];
        // this.isContractSigned = result['signed'] ? result['signed'] : false;
        // this.isValidContract = result['is_valid_form'] ? result['is_valid_form'] : false;
        // this.isSharedWithClient = result['shared_with_client'] ? result['shared_with_client'] : false;
        // this.clientService.contractVersionList = result['versions'].map((item) => item +'');
        // this.isDiscard = result["discard"] ? result["discard"] : false;
        // this.selectedVersion = this.selectedVersion && this.selectedVersion !="" ? this.selectedVersion : result['versions'][0] +'';
      } else {
        this.notifier.notify('error', 'Something went wrong !');
      }
    }, err => {
      this.notifier.notify('error', 'Something went wrong !');
    })
  }

  modifyClientDetailsData(data) {
    this.clientDetailsCont = [];
    Object.keys(data).forEach((key) => {
      let obj  = data[key] && data[key].values && data[key].values.length  ? data[key].values[0] : "";
      if(obj){
        this.clientDetailsCont.push(obj)
      }
    })
  }


  backToExpressList() {
    this.router.navigate(['/client-master/users']);
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      this.notifier.notify('success', 'Copied to clipboard');
    }
    ).catch(err => {
      this.notifier.notify('error', 'Failed to copy text');
    });
  }

  EditClient(){
    if(this.uuid)this.router.navigate(['/client-master/request/'+this.uuid]);
  }


}

